import { render, staticRenderFns } from "./UpdateTaskParamsModal.vue?vue&type=template&id=5878aa86&"
import script from "./UpdateTaskParamsModal.vue?vue&type=script&lang=js&"
export * from "./UpdateTaskParamsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports